// extracted by mini-css-extract-plugin
export default {"warning":"Warning_warning__-dSIG"};